import React, { useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons";

import { parseBoolOr, isObjectNotEmpty, parseStringOr } from "../../helpers/AppxUtils";
import { TvPlanContext } from "../../contexts/tvplancontext";
import TvChannelTile from "../TvChannelTile";
import Price from "../Price";

import "./index.css";
//public props:
// code (string)
// onClick (function)
// removeIfInStarter bool
// selected
// showPlus
// br
// showSelected
// showBorder

export default function TvService(props) {
    const ctx = useContext(TvPlanContext)
    const tvConfig = ctx.getTvConfig();
    const code = props.code;
    const groupCode = parseStringOr(props?.groupCode, "");
    const sconfig = tvConfig.service[code];
    let onClick = props.onClick || null;
    //service not found...
    if (!isObjectNotEmpty(sconfig)) {
    	return (
            <div
                onClick={onClick}
                className="tv-plan-tv-service"
            >
                <TvChannelTile
                    showSelected={props.showSelected}
                    code={code}
                    type="not-found"
                />
            </div>
        );
    }

    if (props.removeIfInStarter == true) {
        if (ctx.serviceIsInStarterPlan(code) == true) {
            return null;
        }
    }

    let ccount = 1;

    if (isObjectNotEmpty(sconfig?.channels)) {
        ccount = sconfig.channels.length;
    }

    let selected = parseBoolOr(props?.selected, false);

    if (!selected && groupCode === "") {
        selected = ctx.isServiceSelected(code);
    }

    let sprice = 0;

    if (isObjectNotEmpty(sconfig?.price)) {
        sprice = sconfig.price.standalone || 0;
    }

    let tileSize = props.tileSize || "small";
    let checkCode = null;
    let myPriceChoice = ctx.getPriceChoice(code);

    if (ccount == 1) {
        let implicit = false;

        if (ctx.isServiceImplicit(code)) {
            implicit = true;

            if (!ctx.isServicePickGoupSelected(code, groupCode)) {
                onClick = () => ctx.showRemoveFavDialog(code);
            }
        }

        return (
            <div
                className="tv-plan-tv-service"
                onClick={onClick}
            >
                <TvChannelTile
                    priceChoice={myPriceChoice}
                    implicit={implicit}
                    selected={selected}
                    showSelected={props.showSelected}
                    size={tileSize}
                    code={code}
                    groupCode={groupCode}
                    pickMode={props.pickMode}
                    showPrice={props.showPrice}
                    myPriceChoice={props.myPriceChoice} />
            </div>
        );
    }
    else {
        let tilesShowSelected = props.showSelected;

        if (sconfig.showAsGroup ==true) {
            tileSize = "small";
            tilesShowSelected = false;
        }

    	let ret = [];

    	for(let i in sconfig.channels) {
            let ch = sconfig.channels[i];
            let hasPlus = false;

            if (sconfig.channels.length > 0 && i < (sconfig.channels.length -1)) {
                hasPlus = true;
            }
            if (props.showPlus == false) { hasPlus = false;}

            let isMultiplex = true;

            if (i == 0) { isMultiplex = false; }

            let implicit = false;

            if (ctx.isServiceImplicit(ch)) {
                implicit = true;

                if (!ctx.isServicePickGoupSelected(ch, groupCode)) {
                    onClick = () => ctx.showRemoveFavDialog(ch);
                }
            }

            ret.push(
                <TvChannelTile
                    key={`service-${code}-ch-${ch}`}
                    priceChoice={myPriceChoice}
                    implicit={implicit}
                    selected={selected}
                    showSelected={tilesShowSelected}
                    size={tileSize}
                    isMultiplex={isMultiplex}
                    hasPlus={hasPlus}
                    serviceCode={code}
                    groupCode={groupCode}
                    code={ch}
                    pickMode={props.pickMode}
                    showPrice={props.showPrice}
                    myPriceChoice={props.myPriceChoice}
                />
            );
    	}

        let serviceClass = "tv-plan-tv-service";
        let containerClass = "tv-plan-tv-service-container";
        let priceCode = null;

        if (props.br == true) { containerClass += " br";}
        if (props.showBorder == true || sconfig.showAsGroup == true) {
            serviceClass +=  " border";
            priceCode = (<div className="tv-plan-tv-service-sa-price"><Price>{sprice}</Price></div>);

            if (sprice < 0.01) { priceCode = null;}
            if (props.selected == true ) {
                serviceClass += " selected";
                checkCode = (<div className='tv-plan-tv-service-check'><FontAwesomeIcon icon={faCheckCircle} /></div>)
            }
        }

    	return (
            <div className={containerClass}>
                <div className="tv-plan-tv-service-content" data-apiCode={code}>
                    <div className={serviceClass} onClick={onClick}>
                        {priceCode}{ret}
                    </div>
                    {checkCode}
                </div>
            </div>
        );
    }
}
